export default "__VITE_ASSET__DdmI8x6o__"